export default {
  methods: {
    mascara_dinheiro(valor) {
      if (!valor) return '';
      return parseFloat(valor).toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
      });
    },

    mascara_juros(valor) {
      if (!valor) return '';
      return parseFloat(valor).toFixed(2) + '%';
    },

    mascara_data(value, style = {}) {
      if (!value) return '';
      const date = new Date(value);
      return date.toLocaleString('pt-br', style);
    },

    mascara_data_calendario(value) {
      if (!value) return '';

      value = value.replace('T00:00:00.000000Z', '');

      return String(value).split('-').reverse().join('/');
    },

    removeTimeFromDate(value) {
      if (!value) {
        return null;
      }

      return value.replace('T00:00:00.000000Z', '');
    },

    mascara(valor, padrao) {
      let index = 0;
      const v = valor.toString();
      return padrao.replace(/#/g, () => v[index++] || '');
    },

    validarPadrao(valor, padroes) {
      if (!valor || typeof valor !== 'string' || !valor.match(/^[0-9a-zA-Z]+$/))
        return valor;
      const mascara = padroes.find((item) => item.length == valor.length);
      if (!mascara) return valor;
      return this.mascara(valor, mascara.padrao);
    },

    mascara_cpf_cnpj(valor) {
      return this.validarPadrao(valor, [
        { length: 11, padrao: '###.###.###-##' },
        { length: 14, padrao: '##.###.###/####-##' },
      ]);
    },

    mascara_cnpj(valor) {
      return this.validarPadrao(valor, [
        { length: 14, padrao: '##.###.###/####-##' },
      ]);
    },

    mascara_cpf(valor) {
      return this.validarPadrao(valor, [
        { length: 11, padrao: '###.###.###-##' },
      ]);
    },

    mascara_cep(valor) {
      return this.validarPadrao(valor, [{ length: 8, padrao: '#####-###' }]);
    },

    mascara_telefone(valor) {
      return this.validarPadrao(valor, [
        { length: 10, padrao: '(##) ####-####' },
        { length: 11, padrao: '(##) # ####-####' },
      ]);
    },

    mascara_placa(valor) {
      return this.validarPadrao(valor, [{ length: 7, padrao: '### ####' }]);
    },

    mascaraDecimalParaPercentual(valor) {
      return `${valor.substring(0, valor.length - 2)}%`;
    },

    formatCurrency(value) {
      let formatedValue = '-';

      if (value) {
        formatedValue = value.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });

        if (formatedValue.indexOf('R$') < 0) {
          formatedValue = `R$ ${formatedValue}`;
        }
      }

      return formatedValue;
    },

    formatCurrencyOnlyNums(value) {
      let formatedValue = '-';

      if (value) {
        formatedValue = value
          .toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
          .replace('R$', '')
          .trim();
      }

      return formatedValue;
    },
  },
};
